import React, { FC, useContext, Fragment } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { NotFoundView } from 'views/Errors/NotFound.view';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { DatabaseListView } from 'views/Panel/SchoolDistricts/DatabaseList/DatabaseList.view';
import { DistrictsListView } from 'views/Panel/SchoolDistricts/DistrictsList/DistrictsList.view';

import {
  ROUTE_SCHOOL_CATCHMENT_ASSIGNMENT_PREVIEW,
  ROUTE_SCHOOL_DISTRICTS,
  ROUTE_SCHOOL_DISTRICTS_DATABASE,
  ROUTE_SCHOOL_DISTRICTS_LIST,
  ROUTE_SCHOOL_DISTRICTS_CATCHMENT_ASSIGNMENT_LIST,
} from 'config/routes';
import { relativePath } from 'utils/navigation/relativePath';
import { LocaleContext } from 'context/locale';
import { CatchmentAssignmentPreview } from 'views/Panel/SchoolDistricts/CatchmentAssignmentPreview/CatchmentAssigmentPreview.view';
import { CatchmentAssignmentListView } from 'views/Panel/SchoolDistricts/CatchmentAssignmentList/CatchmentAssignmentListView.view';

export const SchoolDistrictsView: FC = () => {
  const { trans } = useContext(LocaleContext);

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.SCHOOL-DISTRICTS.DISTRICTS')} static />

      <Routes>
        <Route
          path={relativePath(ROUTE_SCHOOL_DISTRICTS, ROUTE_SCHOOL_DISTRICTS)}
          element={<Navigate to={ROUTE_SCHOOL_DISTRICTS_DATABASE} replace />}
        />
        <Route
          path={relativePath(ROUTE_SCHOOL_DISTRICTS_DATABASE, ROUTE_SCHOOL_DISTRICTS)}
          element={<DatabaseListView />}
        />
        <Route path={relativePath(ROUTE_SCHOOL_DISTRICTS_LIST, ROUTE_SCHOOL_DISTRICTS)} element={<DistrictsListView />} />
        <Route
          path={relativePath(ROUTE_SCHOOL_DISTRICTS_CATCHMENT_ASSIGNMENT_LIST, ROUTE_SCHOOL_DISTRICTS)}
          element={<CatchmentAssignmentListView />}
        />
        <Route
          path={relativePath(`${ROUTE_SCHOOL_CATCHMENT_ASSIGNMENT_PREVIEW}/*`, ROUTE_SCHOOL_DISTRICTS)}
          element={<CatchmentAssignmentPreview />}
        />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </Fragment>
  );
};
